<style lang="scss" scoped>
@import "$vars";
label , span  {
  font-size: 1em;
  strong {
    display: block;
    margin-bottom: 10px !important
  }
  display: block;
  margin-bottom: 20px
}
.card {
  background: #f6f6f6;
  margin-bottom: 1em;
  padding-bottom: 0.8rem;
}
.form-autocomplete {
  margin-bottom: 10px;
  width: 100%;
}
.form-select {
  padding-right: 0 !important
}
.flex-column {
  input, textarea {
    padding: 5px;
    background: transparent
  }
  textarea {
    border-left-width: 0;
    border-right-width: 0;
    border-top-width: 0;
    &::-webkit-input-placeholder { /* Chrome/Opera/Safari */
      padding-top: 3em;
    }
    &::-moz-placeholder { /* Firefox 19+ */
      padding-top: 3em;
    }
    &:-ms-input-placeholder { /* IE 10+ */
      padding-top: 3em;
    }
    &:-moz-placeholder { /* Firefox 18- */
      padding-top: 3em;
    }
  }
}
.description {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
  padding-right: 10px;
  justify-content: space-between;

  .chip {
    margin-bottom: 10px;
    display: inline-block;
  }

  &--sm {
    width: 80%;
  }
}

.toast-warning {
  background: #fcf8e3;
  color: #94794a;
  border-color: #f5f3e0;
  margin-bottom: 10px;
  p {
    margin: 0
  }
}

h5 {
  color: #4a4a4a;
  font-family: $base-font-family;
  font-size: 18px;
  font-weight: 600;
}

h2 {
  color: #4a4a4a;
}
input, select {
  &.select--model {
    padding-right: 0 !important
  }
  &.--selected {
    padding: 8px 0px;
  }
  &.--quantity {
    padding: 3px
  }
}

.chip {
  text-transform: uppercase;
  display: inline;
  font-size: 0.5rem;
  padding: 0.3em 1em;
}

.interactions-alert {
  background: #e9e9e9;
  overflow: hidden;
  padding: 0;
  border: 1px solid #999;
  .card-header {
    background: #e1e1e1;
    padding: 5px 5px 10px 5px;
  }
  .card-body {
    header {
      strong {
        display: inline-flex;
        align-items: center
      }
    }
    padding: 0 10px 10px 10px;
    p {
      margin: 0 5px 10px 5px
    }
  }

  i {
    margin-top: 3px
  }
}
footer {
  margin-top: 20px;
}

.newmedicament__text {
  color: rgb(150, 150, 150);
  font-size: 0.7rem;
  font-weight: 600;
}

.newmedicament__example {
  align-items: stretch;
  display: flex;
  flex-wrap: wrap;
  font-size: 0.65rem;
  font-weight: 600;
  justify-content: space-between;
  width: 50%;

  dt {
    padding: 0;
    margin: 0 0 0.25rem 0;
    width: 50%;
  }

  dd {
    margin: 0 0 0.25rem 0;
    padding: 0;
    width: 50%;
  }
}
</style>

<template>
  <main>
    <strong>MEDICAMENTOS {{getTotalMeds > 0 ? `(${getTotalMeds})` : ''}}</strong>
      <br /><br />

      <!-- Interação medicamentosa -->
      <section
        v-if="medicalInteractions.length > 0"
        class="drug-interaction"
      >
        <header
          class="drug-interaction__header clickable"
          @click="interactionsToggle = !interactionsToggle"
        >
          <p class="drug-interaction__info">
            <span class="chip chip--default">Alerta</span>

            Os remédios prescritos possuem interação medicamentosa. Clique e veja mais.
          </p>

          <i
            :class="`icon-arrow-${interactionsToggle ? 'up' : 'down'}`"
            class="icon"
          />
        </header>

        <transition name="fade_up">
          <article
            v-show="interactionsToggle"
            class="drug-interaction__wrapper"
          >
            <transition-group
              name="fade_up"
              tag="ul"
              class="drug-interaction__list"
            >
              <li
                v-for="(interaction, $index) of medicalInteractions"
                :key="`interaction-${$index}`"
                :class="`interaction--${interaction.gravity}`"
                class="drug-interaction__item"
              >
                <div class="drug-interaction__alert">
                  <div class="drug-interaction__medicaments">
                    <div class="drug-interaction__medicaments-medicament">
                      {{ interaction.med1 }}
                    </div>

                    <i class="icon icon-arrow-left" />
                    <i class="icon icon-arrow-right" />

                    <div class="drug-interaction__medicaments-medicament">
                      {{ interaction.med2 }}
                    </div>
                  </div>

                  <span class="chip" :class="interaction.chip">
                    Interação {{ interaction.gravity }}
                  </span>
                </div>

                <p class="drug-interaction__text">
                  {{ interaction.info }}
                </p>
              </li>
            </transition-group>
          </article>
        </transition>
      </section>
      <!-- /Interação medicamentosa -->

      <transition-group class="d-flex" name="fade_right">
        <article
          v-for="(med, $index) of prescriptionMedicaments"
          v-show="!med.hide"
          :key="`prescription_${(med.id || 'blank')}_${$index}`"
          class="card col-12"
        >
          <header v-if="med.interaction" class="card-header">
            <span class="chip chip--default">Interação</span>
          </header>

          <section
            v-show="newMedicamentFormActive !== $index"
            class="card-body d-flex"
          >
            <!-- :class="med.name && 'description--sm'" -->
            <div
              class="description flex flex-row w-full"
            >
              <!-- Remove partnerSearch de :fields='filterOrLike[1][ap.name][]', 'partnerSearch' -->
              <div class="w-10/12">
                <dr-autocomplete
                  v-if="!med.id"
                  :ref="'autocomplete_' + ($index || 'blank')"
                  endpoint="medicament"
                  :format="'{$name} - {$label}'"
                  :newFilter="true"
                  :fields="[
                    'filterOrLike[1][m.label][]',
                    'filterOrLike[1][m.name][]',
                  ]"
                  :return-format="'object'"
                  :disabled="!med.edit"
                  :store-type="'medicament'"
                  placeholder="Busque pelo nome do medicamento e/ou princípio ativo"
                  @change="selectMedicament(med, $event)"
                  @isEmpty="
                    $event > 0 ? newMedicament = $index : newMedicament = false;
                    newMedicamentToast = true;
                  "
                  @typed="
                    autocompleteValue = $event;
                    med.name = null;
                    newMedicamentToast = false;
                  "
                />

                <textarea
                  v-if="med.id"
                  v-model="med.name"
                  rows="1"
                  disabled
                  class="h-4"
                  style="
                    width: calc(100% - 15px);
                    min-height: 16px;
                    height: 37px;
                    padding: 8px;
                    margin-bottom: 10px;
                    background: white;
                    box-sizing: border-box;
                    border-bottom: 1px solid rgb(202, 202, 202);
                    opacity: 0.5;
                  "
                />
              </div>

              <div
                v-if="med.name"
                class="text-center flex-column flex-space_between w-2/12 pl-0"
              >
                <div class="flex flex-row w-full content-box">
                  <input
                    v-model="med.quantity"
                    :disabled="!med.edit"
                    class="form-select --quantity ml-2 w-2/12"
                    type="number"
                    min="1"
                    style="width: 30px"
                  >

                  <select
                    v-model="med.measureUnity"
                    :disabled="!med.edit"
                    class="form-select w-9/12 ml-2"
                    style="padding-bottom: 0; margin-left: 5px; width: calc(100% - 30px)"
                  >
                    <option disabled :value="0">Medida</option>

                    <option
                      v-for="(unity, index) in measureUnities.filter(m => m['is_active'])"
                      :key="`measureUnity-${index}`"
                      :value="unity.name"
                    >
                      {{ unity.name }}
                    </option>
                  </select>
                </div>
              </div>

              <transition name="fade">
                <div
                  v-if="newMedicament === $index"
                  class="col-8"
                >
                  <div
                    v-if="newMedicamentToast !== $index"
                    class="toast toast-warning"
                  >
                    <p>
                      <button
                        class="btn btn-clear float-right"
                        @click="newMedicamentToast = false"
                      />

                      <small>
                        <b>Atenção!</b> Este medicamento não consta em nosso
                        banco de dados. Mas você pode cadastrá-lo e seguir
                        com o cadastro de sua receita.
                      </small>
                    </p>
                  </div>

                  <button
                    class="btn btn-sm btn-primary"
                    @click="
                      newMedicamentFormActive = $index;
                      newMedicamentForm.product = autocompleteValue;
                    "
                  >
                    Cadastrar novo medicamento
                  </button>
                </div>
              </transition>

              <div
                v-if="med.name"
                class="d-flex flex-column col-12"
              >
                <small v-if="!med.edit" class="font-bold ml-1">Posologia:</small>
                <input
                  v-model="med.posology"
                  :disabled="!med.edit"
                  placeholder="Posologia"
                  maxlength="255"
                  type="text"
                  class="form-text my-2 "
                  :class="med.edit ? '!bg-white' : ''"
                />
                <small v-if="!med.edit" class="font-bold ml-1">Observações:</small>
                <textarea
                  v-model="med.note"
                  :disabled="!med.edit"
                  rows="3"
                  resize="false"
                  class="form-textarea"
                  :placeholder="med.edit ? 'Observações' : ''"
                  :class="med.edit ? '!bg-white' : ''"
                />

                <label class="form-checkbox">
                  <input
                    type="checkbox"
                    :disabled="!med.edit"
                    :checked="med.isSpecialPrescription ? true : false"
                    @click="$event => setMedicamentSpecialControl(med, $event)"
                  />
                  <i class="form-icon" /> Medicamento de uso controlado?
                </label>
              </div>

              <div class="w-full">
                <button
                  v-if="med.id"
                  type="button"
                  class="btn btn-sm btn-error margin-center"
                  @click="removeMedicament($index)"
                >
                  Remover
                </button>

                <button
                  v-if="med.id && med.edit"
                  :disabled="med.posology.length < 4"
                  type="button"
                  class="btn btn-sm btn-green margin-center"
                  @click="editMedicament($index)"
                >
                  Salvar
                </button>

                <button
                  :disabled="med.posology.length < 4 || med.measureUnity === 0"
                  v-if="!med.id && med.edit"
                  type="button"
                  class="btn btn-sm btn-green margin-center"
                  @click="storeMedicament($index)"
                >
                  Adicionar
                </button>
              </div>
            </div>
          </section>

          <section
            v-show="newMedicamentFormActive === $index"
            class="card-body d-flex"
          >
            <form
              class="col-12"
              @submit.prevent="submitMedicament($index)"
            >
              <h5 class="col-12">Cadastro de novo medicamento</h5>

              <p class="newmedicament__text">
                Cadastre um novo medicamento através do formulário abaixo,
                informando o nome do medicamento, a concentração ou unidade,
                e os princípios ativos, como no exemplo abaixo:
              </p>

              <dl class="newmedicament__example">
                <dt>Nome do medicamento:</dt>
                <dd>Novalgina</dd>

                <dt>Concentração/unidade:</dt>
                <dd>Solução oral 50mg/ml</dd>

                <dt>Princípio ativo:</dt>
                <dd>Dipirona monoidratada</dd>
              </dl>

              <p class="newmedicament__text">
                Ao informar o princípio ativo, clique em + para confirmar.
              </p>

              <div class="column col-11">
                <div class="description">
                  <dr-field
                    prefix="form1"
                    class="column intervals"
                    v-for="(field, name) in newMedicamentForm"
                    :form.sync="newMedicamentForm"
                    :field="field"
                    :validators.sync="$v.newMedicamentForm[field]"
                    :apiErrors.sync="apiErrors[name]"
                    :key="'field' + name"
                    :id="'intervals'+name"
                    :ref="'newMedicament_' + name"
                  />
                </div>

                <footer class="flex-end col-12">
                  <button
                    class="btn btn-sm btn-default"
                    @click="
                      newMedicamentFormActive = false;
                      newMedicament = false;
                      newMedicamentToast = true;
                    "
                  >
                    Cancelar
                  </button>

                  &ensp;

                  <dr-submit
                    :disabled="$v.newMedicamentForm.$invalid"
                    :sending="sending"
                    size="sm"
                    text="Cadastrar"
                  />
                </footer>
              </div>
            </form>
          </section>
        </article>
      </transition-group>
    </main>
</template>

<script>
import drAutocomplete from '@/components/form/autocomplete'
import drField from '@/components/form/field'
import drSubmit from '@/components/form/submit'
import {formData, validations} from '@/data/formData/newMedicament'

export default {
  props: ['models', 'selectedModel', 'resetForm'],
  components: {
    drAutocomplete,
    drField,
    drSubmit
  },
  data () {
    return {
      prescriptionMedicaments: [
        {
          index: this.medIndex,
          id: null,
          externalId: null,
          interaction: false,
          name: '',
          posology: '',
          note: '',
          edit: true,
          isSpecialPrescription: false,
          quantity: 1,
          measureUnity: 0
        }
      ],
      details: '',
      checking: false,
      sending: false,
      rawNote: null,
      prescriptionId: null,
      prescriptions: [],
      interactionsToggle: false,
      interactionIndex: 0,
      medicalInteractions: [],
      autocompleteValue: null,
      newMedicament: null,
      newMedicamentToast: true,
      newMedicamentFormActive: false,
      newMedicamentForm: formData,
      formValid: false,
      medSpecial: '',
      apiErrors: this.fn_BUILD_API_ERRORS(formData),
      medicament: {
        name: null,
        posology: null,
        quantity: null,
        index: 0,
        id: 0,
        isSpecialPrescription: false,
        measureUnity: 0
      },
      medIndex: 0,
      editorConfig: {
        language: 'pt-br',
        removePlugins: [ 'Heading', 'Link' ],
        toolbar: ['bold', 'italic', 'strikethrough', 'bulletedList', 'numberedList', 'blockQuote', 'undo', 'redo']
      },
      measureUnities: []
    }
  },
  validations: {
    newMedicamentForm: validations
  },
  computed: {
    getTotalMeds () {
      let i = 0
      for (let med of this.prescriptionMedicaments) {
        if (med.id) {
          i++
        }
      }
      return i
    }
  },
  watch: {
    getTotalMeds (next) {
      this.$emit('updated', this.prescriptionMedicaments)
      if (next > 0) {
        this.$emit('formValid', true)
        return
      }
      this.$emit('formValid', false)
    },
    newMedicamentFormActive (next) {
      this.$emit('newMedicamentFormActive', next)
    },
    formValid (next) {
      this.$emit('formValid', next)
    },
    selectedModel (next) {
      this.loadModel(next)
    },
    checking (next) {
      this.$emit('checked', next)
    },
    resetForm (next) {
      if (next) {
        this.medicalInteractions = []
        this.prescriptionMedicaments = [
          {
            index: this.medIndex,
            id: null,
            name: '',
            activePrinciples: null,
            label: '',
            posology: '',
            note: '',
            isSpecialPrescription: false,
            edit: true,
            quantity: 1,
            measureUnity: 0
          }
        ]
        this.resetAutocompletes()
      }
    }
  },

  created () {
    this.getMeasureUnities()
      .then(res => (this.measureUnities = res))
  },

  methods: {
    hasMedicament () {
      return this.medicament.name && this.medicament.quantity && this.medicament.posology
    },

    loadModel (modelId) {
      this.medIndex = 0
      if (modelId === null) {
        this.prescriptionMedicaments = [
          {
            index: this.medIndex,
            id: null,
            name: '',
            brand: '',
            posology: '',
            note: '',
            isSpecialPrescription: false,
            edit: true,
            quantity: 1,
            measureUnity: 0
          }
        ]
        return
      }
      let model = {}
      for (let i of this.models) {
        if (i.id === modelId) {
          model = i
        }
      }
      this.id = model.id
      this.name = model.name
      this.isSpecialPrescription = model.isSpecialPrescription
      this.prescriptionMedicaments = []
      let index = model['prescription_model_medicaments'].length
      let medicament = {
        index: this.medIndex,
        id: null,
        externalId: null,
        interaction: false,
        name: '',
        label: '',
        posology: '',
        note: '',
        isSpecialPrescription: false,
        edit: true,
        quantity: 1,
        measureUnity: 0
      }
      for (let i = index; i < model['prescription_model_medicaments'].length + index; i++) {
        this.storeMedicament(i, model['prescription_model_medicaments'][i - model['prescription_model_medicaments'].length])
      }
      this.prescriptionMedicaments.unshift(medicament)
      // this.checkInteractions()
      this.formValid = true
    },

    selectMedicament (med, data) {
      if (data) {
        let ev = this.fn_COPY_OBJECT(data)

        let activePrinciples = []
        for (let principle in ev.active_principles) {
          activePrinciples.indexOf(ev.active_principles[principle].name[0])
        }
        // med.name = `${ev.id}||${ev.name} (${activePrinciples.join(', ')}) - ${ev.label}`
        med.name = `${ev.id}||${ev.name} - ${ev.label}`
        med.label = ev.name
        med.externalId = ev.external_id
        med.specialControl = ev.special_control
        med.isSpecialPrescription = ev.special_control
        return
      }
      med.name = null
    },
    checkInteractions (remove) {
      const arr = []
      let send = false
      if (this.prescriptionMedicaments.length > 2) {
        for (let prescriptionMedicament of this.prescriptionMedicaments) {
          if (prescriptionMedicament.externalId) {
            arr.push({
              externalId: prescriptionMedicament.externalId
            })
            send = true
          }
        }
      }
      if (!send) {
        for (let med of this.prescriptionMedicaments) {
          med.interaction = false
        }
        this.medicalInteractions = []
        return
      }
      this.fn_SHOW_PROGRESS()
      this.checking = true
      this.$http.post(`medicament/drug_interaction`, {drug_interaction: {medicaments: arr}}, this.$store.getters.getAuthHeader).then(
        (res) => {
          const self = this
          let arr = res.data.Interacoes
          // diclofenaco , dipirona, metotrexato, hidrocloro
          function getMed (medId, reset) {
            for (let medPres of self.prescriptionMedicaments) {
              if (reset) {
                medPres.interaction = false
              } else {
                if (medPres.externalId === medId) {
                  medPres.interaction = true
                  return medPres.label
                }
              }
            }
          }
          getMed(null, true)
          this.medicalInteractions = []
          for (let item of arr) {
            if (item.Medicamento2) {
              let obj = {}
              this.interactionIndex += 1
              obj.id = this.interactionIndex
              obj.chip = 'chip' + (item.Gravidade === 'Grave' ? '--danger' : item.Gravidade === 'Moderada' ? '--warning' : '--info')
              obj.med1 = getMed(item.Medicamento1.idMedicamento)
              obj.med2 = getMed(item.Medicamento2.idMedicamento)
              obj.gravity = item.Gravidade
              obj.info = item.Descricao
              this.medicalInteractions.push(obj)
            }
          }
        }
      ).catch(
        (err) => {
          console.log(err)
        }
      ).finally(
        () => {
          this.fn_HIDE_PROGRESS()
          this.checking = false
        }
      )
    },
    storeMedicament (index, med) {
      // if (this.prescriptionMedicaments.length > 1 && this.medSpecial.length === 1) {
      //   return false
      // }

      this.medIndex = this.medIndex + 1
      let medicament = {
        index: this.medIndex,
        id: null,
        externalId: null,
        interaction: false,
        name: '',
        label: '',
        posology: '',
        note: '',
        edit: true,
        quantity: 1,
        measureUnity: 0
      }

      // console.log('med is', med)
      if (med) {
        this.prescriptionMedicaments.unshift({
          edit: false,
          id: med.medicament.id,
          externalId: med.medicament.external_id,
          interaction: false,
          name: med.medicament.name + ' - ' + med.medicament.label,
          label: med.medicament.name,
          posology: med.posology,
          quantity: med.quantity,
          note: med.note,
          isSpecialPrescription: med.is_special_prescription,
          measureUnity: med['medicament_prescription_quantity_unity']
        })
        return
      }

      let medName = this.prescriptionMedicaments[index].name.slice(0)
      this.formValid = true
      this.prescriptionMedicaments[index].edit = false
      this.prescriptionMedicaments[index].id = medName.split('||')[0]
      this.prescriptionMedicaments[index].name = medName.split('||')[1]
      this.prescriptionMedicaments.unshift(medicament)
      this.medicament.externalId = null
      this.medicament.externalId = false
      this.medicament.product = null
      this.medicament.label = null
      this.medicament.posology = null
      this.medicament.quantity = null
      this.medicament.measureUnity = 0
      this.autocompleteValue = ''
      // this.checkInteractions()
      this.resetAutocompletes()
    },
    resetAutocompletes () {
      setTimeout(() => {
        this.$refs['autocomplete_blank'][0].resetValues()
      }, 200)
      // for (let ref in this.$refs) {
      //   if (this.$refs[ref][0]) {
      //     if (this.$refs[ref][0].resetValues) {
      //       this.$refs[ref][0].resetValues()
      //     }
      //   }
      // }
    },
    removeMedicament (index) {
      this.prescriptionMedicaments.splice(index, 1)
      // this.checkInteractions(true)
      if (this.prescriptionMedicaments.length <= 1) {
        this.medicalInteractions = []
      }
    },
    checkFields () {
      if (this.prescriptionMedicaments.length === 0) {
        return true
      }
      for (let prescription of this.prescriptionMedicaments) {
        if (prescription.posology.length <= 4) {
          return true
        }
      }
    },
    submitMedicament (index) {
      if (this.$v.newMedicamentForm.$invalid) {
        return
      }
      this.fn_SHOW_PROGRESS()
      this.sending = true
      let data = this.fn_EXPAND_OBJECT(this.newMedicamentForm)
      const { activePrinciples } = data
      const temp = []

      activePrinciples.forEach((principle, index) => {
        temp[index] = { ...principle }
      })

      data.activePrinciples = [ ...temp ]
      const { label, name } = data
      data.name = name.trim()
      data.label = `${name.trim()} - ${label.trim()}`

      this.$http.post(`/doctor/medicament`, {medicament: data}, this.$store.getters.getAuthHeader).then(
        (res) => {
          this.prescriptionMedicaments[index].name = `${res.data}||${data.name}`
          this.autocompleteValue = data.name
          this.newMedicamentFormActive = false
          this.newMedicament = false
          this.newMedicamentToast = true
          for (let field in this.newMedicamentForm) {
            this.newMedicamentForm[field].value = null
          }
          this.$refs.autocomplete_blank[0].searchTerm = data.name
        }
      ).catch(
        (err) => {
          if (err.status === 400 || err.code === 400) {
            this.fn_FLATTEN_OBJECT(err.errors.children).then(
              (res) => {
                for (let field in res) {
                  this.apiErrors[field.replace(/.children|.errors/g, '')] = res[field]
                }
                this.sending = false
                this.$store.dispatch('setModalAlert', this.ERROR_MESSAGES.modal.form)
              }
            )
          } else {
            console.log(err)
            this.sending = false
          }
        }
      ).finally(
        () => {
          this.sending = false
          this.fn_HIDE_PROGRESS()
          this.$refs['newMedicament_activePrinciples'][0].arraySelected = []
        }
      )
    },

    getMeasureUnities () {
      return new Promise(resolve => {
        const url = '/medicament_prescription_quantity_unity?itensPerPage=all'

        this.$http
          .get(url, this.$store.getters.getAuthHeader)
          .then(res => resolve(res.data.data))
      })
    },

    setMedicamentSpecialControl (medicament, $event) {
      const alertMsg = (phrase, status) => this.$store.dispatch('setModalConfirm', {
        title: 'Aviso',
        body: `O medicamento escolhido está configurado em nossa base de dados (oriunda da ANS)
          como um medicamento que <strong>${phrase}</strong> de uso controlado. Deseja realmente classifica-lo
          como um medicamento de uso controlado?
        `,
        confirmText: 'Confirmar',
        cancelText: 'Cancelar',
        beforeClose: (v) => {
          if (v) {
            this.$set(medicament, 'isSpecialPrescription', status)
          }

          this.$store.dispatch('setModalConfirm')
        },
        size: 'md',
        active: true
      })

      if (medicament.specialControl && medicament.isSpecialPrescription) {
        $event.preventDefault()
        alertMsg('é', false)
        return
      }

      if (medicament.specialControl && !medicament.isSpecialPrescription) {
        this.$set(medicament, 'isSpecialPrescription', true)
        return
      }

      if (!medicament.specialControl && !medicament.isSpecialPrescription) {
        $event.preventDefault()
        alertMsg('não é', true)
        return
      }

      if (!medicament.specialControl && medicament.isSpecialPrescription) {
        this.$set(medicament, 'isSpecialPrescription', false)
      }
    }
  }
}
</script>
